<p-card class="member-preview col-12" *ngIf="showMemberInfo">
  <div class="">
    <app-member-information [member]="member" (memberUpdated)="memberUpdated($event)" (memberDeleted)="handleMemberDeletion($event)"></app-member-information>
  </div>
</p-card>
<p-toast></p-toast>
